var exports = {
  "Mx": "PageLayout__1ulfPP",
  "O3": "PageLayoutPane__Qu_Bwm",
};

module.exports = exports;
